import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  COMPANY_ID,
  CONTACT_ID,
  CUSTOMER_PURCHASE_ORDER_NUMBER,
  EMAIL,
  NAME
} from "APP_ROOT/constants";
import { CONTACT } from "MODULES/companies/constants";
import { CREDIT_TERMS } from "MODULES/SalesOrders/constants";

export function validateCustomerFields(values, form) {
  if (values.contact_id === "Add") {
    form.validateChild(CONTACT, contactForm => {
      contactForm.validate(EMAIL, NAME).satisfies(rules.required);
      contactForm.validate(EMAIL).satisfies(rules.isValidEmail);
    });
  }
  return form
    .validate(
      COMPANY_ID,
      CONTACT_ID,
      CREDIT_TERMS,
      CUSTOMER_PURCHASE_ORDER_NUMBER
    )
    .satisfies(rules.required);
}

export default function(values) {
  return validator(values, form => {
    validateCustomerFields(values, form);
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/CustomerSection/validate.js